import TechnologyAdvancedView from './TechnologyAdvancedView'

export default TechnologyAdvancedView
